import { atomWithStorage } from 'jotai/utils';

export const atomShowCampaignsV1 = atomWithStorage(
  'profile/showCampaignV1',
  localStorage.getItem('profile/showCampaignV1')
);
